import { auth } from '../firebase';
import { invalidateAnalyticsSessionCache } from './atsAnalyticsService';

const PROD_BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL_PROD ||
  process.env.REACT_APP_BACKEND_URL ||
  'http://localhost:8000';

const DEV_BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL_PROD ||
  process.env.REACT_APP_BACKEND_URL ||
  'http://127.0.0.1:8000';

const BACKEND_URL = process.env.NODE_ENV === 'production'
  ? PROD_BACKEND_URL
  : DEV_BACKEND_URL;

async function authHeaders() {
  const user = auth.currentUser;
  if (!user) return { 'Content-Type': 'application/json' };
  const token = await user.getIdToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  };
}

async function parseJson(response) {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { raw: text };
  }
}

async function request(path, body, { auth = true } = {}) {
  const response = await fetch(`${BACKEND_URL}${path}`, {
    method: 'POST',
    headers: auth ? await authHeaders() : { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {})
  });
  const payload = await parseJson(response);
  if (!response.ok || payload?.success === false) {
    const error = new Error(payload?.detail || payload?.error || `HTTP ${response.status}`);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }
  return payload;
}

async function mutatingRequest(path, body, options = {}) {
  const payload = await request(path, body, options);
  invalidateAnalyticsSessionCache(body?.companyUID || body?.company_uid || '');
  return payload;
}

export const offerApi = {
  backendUrl: BACKEND_URL,

  saveDraft(companyUID, offer, offerId = null) {
    return mutatingRequest('/offers/save-draft', { companyUID, offerId, offer });
  },

  submitForApproval(companyUID, offer, offerId = null) {
    return mutatingRequest('/offers/submit-for-approval', { companyUID, offerId, offer });
  },

  send(companyUID, offer, offerId = null) {
    return mutatingRequest('/offers/send', { companyUID, offerId, offer });
  },

  approveAndSend(companyUID, offerId, note = '') {
    return mutatingRequest('/offers/approve-and-send', { companyUID, offerId, note });
  },

  rejectApproval(companyUID, offerId, reason) {
    return mutatingRequest('/offers/reject-approval', { companyUID, offerId, reason });
  },

  manualAccept(companyUID, offerId, acceptedAt = null) {
    return mutatingRequest('/offers/manual-accept', { companyUID, offerId, acceptedAt });
  },

  resolvePublic(token) {
    return request('/offers/public/resolve', { token }, { auth: false });
  },

  respondPublic(token, action, payload = {}) {
    return mutatingRequest('/offers/public/respond', { token, action, ...payload }, { auth: false });
  }
};

export default offerApi;
